import * as TypeGraphQL from "type-graphql";
export var SignalOutcomeScalarFieldEnum;
(function (SignalOutcomeScalarFieldEnum) {
    SignalOutcomeScalarFieldEnum["id"] = "id";
    SignalOutcomeScalarFieldEnum["timestamp"] = "timestamp";
    SignalOutcomeScalarFieldEnum["signalId"] = "signalId";
    SignalOutcomeScalarFieldEnum["generatorSource"] = "generatorSource";
    SignalOutcomeScalarFieldEnum["symbol"] = "symbol";
    SignalOutcomeScalarFieldEnum["signalType"] = "signalType";
    SignalOutcomeScalarFieldEnum["originalConfidence"] = "originalConfidence";
    SignalOutcomeScalarFieldEnum["priorityScore"] = "priorityScore";
    SignalOutcomeScalarFieldEnum["outcome"] = "outcome";
    SignalOutcomeScalarFieldEnum["pnlPercentage"] = "pnlPercentage";
    SignalOutcomeScalarFieldEnum["timeToOutcome"] = "timeToOutcome";
    SignalOutcomeScalarFieldEnum["outcomeTimestamp"] = "outcomeTimestamp";
    SignalOutcomeScalarFieldEnum["outcomeReason"] = "outcomeReason";
    SignalOutcomeScalarFieldEnum["generatedAt"] = "generatedAt";
    SignalOutcomeScalarFieldEnum["marketConditions"] = "marketConditions";
})(SignalOutcomeScalarFieldEnum || (SignalOutcomeScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(SignalOutcomeScalarFieldEnum, {
    name: "SignalOutcomeScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=SignalOutcomeScalarFieldEnum.js.map